let data: any;

export const loadConfig = (configuration: any) => {
  data = configuration;
};

export const getConfig = (key: string): string | undefined => {
  if (process.env.NODE_ENV === 'production') {
    return data[key];
  } else {
    return process.env[key];
  }
};
